export const PRIMARY_JAF_DOMUS = "jaf-domus";
export const SECONDARY_LATO = "Lato";
